<template>
  <div id="app" v-if="user !== undefined">
    <router-view id="view" :profile="profile" :user="user" v-if="!user.uid || (user.uid && profile && profile.email)"/>
<!--
    <main>

    </main> -->

    <!-- <b-container style="margin-top: 56px" fluid>
      <header>
        <Header :profile="profile" :user="user"/>
      </header>

      <footer>
        <Footer :profile="profile" :user="user"/>
      </footer>
    </b-container> -->
  </div>
</template>

<script>
// eslint-disable-next-line
import { db, auth, analytics } from '@/main.js'
import { version } from "../package.json"

function isPWA() {
  return window && window.matchMedia("(display-mode: standalone)").matches;
}

export default {
  name: 'App',
  data () {
    return {
      profile: undefined,
      user: undefined
    }
  },
  metaInfo: {
    changed(metaInfo) {
      analytics().setCurrentScreen(metaInfo.title);
      analytics().logEvent("page_view");
      analytics().logEvent("screen_view", {
        app_name: isPWA() ? "pwa" : "web",
        screen_name: metaInfo.title,
        app_version: version
      })
    }
  },
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user
        this.$bind('profile', db.collection('user').doc(user.uid))
      } else {
        this.user = {}
        try {
          this.$unbind('profile')
        } catch (err) {
          //
        }

        // TEST TODO
        console.log('123')
        if (this.$route.name !== 'login' || this.$route.name !== 'home') {
          this.$router.push({name: 'home'})
        }

      }
    })
  }
}

</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Eczar:wght@400;700&family=Montserrat:wght@400;700&family=Poppins:wght@400;700&family=Roboto:wght@400;500;700&family=Source+Serif+Pro:wght@400;600;700&family=Spectral:wght@400;700&display=swap');

</style>
